<div *ngIf="isOpen" class="fixed inset-0 z-40 pointer-events-none">
  <div class="absolute inset-0 bg-black/30 pointer-events-auto" (click)="close()"></div>

  <aside class="absolute right-0 top-0 h-full w-full max-w-[440px] bg-white shadow-2xl pointer-events-auto flex flex-col">
    <header class="px-6 pt-6 pb-4 border-b border-gray-200 flex items-start justify-between gap-4">
      <div class="flex items-start gap-3 min-w-0">
        <div class="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0">
          <mat-icon class="text-primary">notifications</mat-icon>
        </div>

        <div class="min-w-0">
          <h2 class="text-xl font-semibold text-primary-dark">Central de Notificações</h2>
          <p class="text-sm text-primary-gray mt-1">{{ badgeLabel() }} novas notificações</p>
        </div>
      </div>

      <div class="flex items-center gap-2 flex-shrink-0">
        <button
          *ngIf="hasUnreadNotifications"
          type="button"
          class="rounded-lg bg-primary text-white px-3 py-2 text-sm font-medium hover:opacity-95 disabled:opacity-60 disabled:cursor-not-allowed"
          (click)="markAllAsRead()"
        >
          Marcar todas como lidas
        </button>

        <button type="button" class="w-8 h-8 rounded-full text-gray-500 hover:bg-gray-100 flex items-center justify-center" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </header>

    <div #scrollContainer class="flex-1 overflow-y-auto px-5 py-4" (scroll)="onScroll()">
      <div *ngIf="!notifications.length && !isLoading" class="h-full min-h-[260px] flex flex-col items-center justify-center text-center px-4">
        <div class="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 overflow-visible">
          <mat-icon class="text-gray-400 text-[36px] leading-none">notifications_none</mat-icon>
        </div>
        <p class="text-base font-semibold text-primary-dark mt-3">Nenhuma notificação no momento</p>
        <p class="text-sm text-primary-gray mt-1">Quando houver novos alertas do sistema, eles aparecerão aqui.</p>
      </div>

      <div class="flex flex-col gap-5" *ngIf="notifications.length">
        <section *ngFor="let group of groupedNotifications" class="flex flex-col gap-3">
          <h3 class="text-xs font-semibold uppercase tracking-wide text-primary-gray">{{ group.label }}</h3>

          <button
            *ngFor="let notification of group.items; trackBy: trackByNotificationId"
            type="button"
            [attr.data-notification-id]="notification.id"
            class="w-full text-left rounded-xl border border-gray-200  px-4 py-3 transition-colors hover:bg-gray-50 relative"
            [class.pl-3]="!notification.isRead"
            [class.bg-blue-50]="!notification.isRead"
            [class.bg-gray-50]="notification.isRead"
            (click)="openNotification(notification)"
          >
            <span *ngIf="!notification.isRead" class="absolute left-0 top-0 h-full w-1 rounded-l-xl bg-blue-600"></span>
            <span *ngIf="notification.isRead" class="absolute left-0 top-0 h-full w-1 rounded-l-xl bg-gray-200"></span>

            <div class="flex items-start gap-3">
              <div class="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" [class.bg-blue-500]="!notification.isRead" [class.bg-gray-200]="notification.isRead">
                <mat-icon class="text-[22px]" [class.text-white]="!notification.isRead" [class.text-gray-500]="notification.isRead">campaign</mat-icon>
              </div>

              <div class="min-w-0 flex-1">
                <p class="font-semibold text-primary-dark leading-5">{{ notification.title }}</p>
                <p class="text-sm text-gray-600 mt-2 leading-5">{{ notification.message }}</p>

                <div class="mt-2 flex items-center text-[11px] text-gray-500">
                  <mat-icon class="text-[14px] w-[14px] h-[14px]">schedule</mat-icon>
                  <span class="mb-3">{{ metadataLabel(notification.createdAt) }}</span>
                </div>
              </div>
            </div>
          </button>
        </section>
      </div>

      <div *ngIf="isLoading" class="py-4 flex justify-center">
        <p class="text-sm text-primary-gray">Carregando notificações...</p>
      </div>
    </div>
  </aside>
</div>
